import { render, staticRenderFns } from "./quickAuthorization.vue?vue&type=template&id=27fb1760&scoped=true"
import script from "./quickAuthorization.vue?vue&type=script&lang=js"
export * from "./quickAuthorization.vue?vue&type=script&lang=js"
import style0 from "./quickAuthorization.vue?vue&type=style&index=0&id=27fb1760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb1760",
  null
  
)

export default component.exports